import type { AppStore } from './store';

let store: AppStore;

export const setStore = (_store: AppStore) => {
  store = _store;
};

export const getStore = (): AppStore => {
  if (!store) throw new Error('Store not set');
  return store;
};